// views
import { Card } from "antd";
import PostLink from "~/components/post/PostLink";
import SuggestItem from "~/components/app/SuggestItem"

const RelatedPostList = (props) => {
  return (
    <Card title="推荐帖子">
      {props.suggests.posts && props.suggests.posts.map((post) => (
        <SuggestItem key={post.id}>
          <PostLink post={post} />
        </SuggestItem>
      ))}
    </Card>
  );
};

export default RelatedPostList;
